module.exports = __webpack_public_path__ + "media/assets/silverFooter-8df4da1f036a6ba520a381722f9e8ba8.png";